import moment from "moment"

export const getDurationBetweenTimestamps = (start: string, end: string): string => {
	const duration = moment.duration(moment(end).diff(moment(start)))
	return `${duration.hours()} hr${duration.hours() > 1 ? "s" : ""}${duration.minutes() > 0 ? `, ${duration.minutes()} mins` : ""}`
}

export const getOneHourSlotFromStartEpoch = (timeStamp: string | number) => {
	const startTime = moment(timeStamp).format("DD MMM YYYY, hh:mm A")
	const endTime = moment(timeStamp).add(1, "hour").format("hh:mm A")
	return `${startTime} - ${endTime}`
}
